<template>
    <div>
        <l-marker :lat-lng="latLng" @ready="$emit('ready', $event)" :visible="isVisible" @click="$emit('click')">
            <l-icon :icon-anchor="isPoint ? [20, 41] : [4, 4]" :class-name="isPoint
                ? Object.entries(iconClasses)
                    .filter(([cls, x]) => x)
                    .map(([cls]) => cls)
                    .join(' ')
                : ''
                ">
                <slot name="icon" />
            </l-icon>
            <l-popup v-if="popupContent || $slots.popup" :content="popupContent" :options="{
                closeButton: false,
                className: 'popup-content',
                autoPan: false,
                autoClose: false
            }">
                <slot name="popup" />
            </l-popup>
        </l-marker>
        <l-polyline :visible="showLiveTail" :lat-lngs="polylineLatLangs" :color="'#37474f'"
            :weight="5" :opacity="0.8" />
        <l-polyline :visible="showLiveTail" :lat-lngs="polylineLatLangs" :color="deviceColor"
            :weight="2" :opacity="1" />
    </div>
</template>

<script>
import { LIcon, LPopup, LMarker, LPolyline } from 'vue2-leaflet'
import { mapGetters } from 'vuex'
export default {
    components: {
        LIcon,
        LPopup,
        LMarker,
        LPolyline,
    },
    props: {

        deviceColor: {
            type: String,
            default: '#37474f',
        },
        devicePosition: {
            type: Object,
            // required: true,
            default: () => { },
        },
        latLng: {
            // [lat, lng]
            type: Array,
            required: true,
        },
        device: {
            type: Object,
            default: () => { },
        },
        visible: {
            type: Boolean,
            default: true,
        },
        popupContent: {
            type: String,
            default: '',
        },
        point: {
            type: Object,
            default: () => ({}),
        },
        isMeta: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            positionsHistory: [],
        }
    },
    computed: {
        ...mapGetters(['isPlaybackReady', 'isShowDeviceTails']),
        trackpointsIds() {
            if (this.point.location) {
                return Object.values(this.point.trackpoints)
            }
            return []
        },
        showLiveTail() {
            return (this.isVisible && this.isShowDeviceTails)
        },
        polylineLatLangs() {
            const LimitTo = 1; // minutes
            const LimitToPoints = 5; // last gpsPoints
            let markerTail = this.positionsHistory.filter(
                p => p.fixTime >= Date.now() - 1000 * 60 * LimitTo
            );
            if (markerTail.length <= LimitToPoints) {
                markerTail = this.positionsHistory.slice(Math.max(this.positionsHistory.length - LimitToPoints, 0))
            }
            return [markerTail.map((p) => {
                return [p.latLng[0], p.latLng[1]]
            })]
        },
        isPoint() {
            return Boolean(this.point.location)
        },
        isVisible() {
            if (
                !this.isPlaybackReady ||
                (this.isPlaybackReady && this.isPoint)
            ) {
                return this.visible
            }
            return false
        },
        // Classes from map competition point.
        iconClasses() {
            return {
                marker: true,
                'marker--with-icons': true,
                'marker--disabled': this.disabled,
                'marker--red': this.isMeta && !this.disabled,
                'w': this.trackpointsIds.length >= 1,
            }
        },
    },
    watch: {
        devicePosition: {
            deep: true,
            handler(newVal, oldVal) {
                if (newVal.latitude !== oldVal.latitude && newVal.longitude !== oldVal.longitude) {
                    if (newVal && newVal.latitude && newVal.longitude && newVal.fixTime) {
                        if (!this.positionsHistory.some(
                            p => p.latLng[0] === newVal.latitude && p.latLng[1] === newVal.longitude)) {
                            this.positionsHistory.push({
                                latLng: [newVal.latitude, newVal.longitude],
                                fixTime: new Date(newVal.fixTime).getTime()
                            });
                        }
                    }
                }
            },
        },
    },
}
</script>
<style lang="scss">
.w {
    width: unset !important;
}

.marker {
    background-color: $slate-two;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;

    &--red {
        background-image: linear-gradient(to left,
                $red-orange 100%,
                $pinky-red 1%);
    }

    &--disabled {
        background-color: $bluish-grey;
    }

    &--with-icons {
        display: flex !important;
        padding: 4px;
        width: unset;
        height: unset !important;
        box-sizing: unset;
    }
}
</style>
